import * as React from 'react'

import { i18n } from '@thg-commerce/enterprise-core'
import { styled, spacing, mq, Text, css } from '@thg-commerce/enterprise-theme'
import { SafeHtml } from '@thg-commerce/gravity-elements'

export interface QuestionAndAnswerProps {
  items: {
    question: string
    answer: string
  }[]
}

const QALetters = styled.span`
  ${Text('large2', 'alternate')}
  margin-right: ${spacing(6)};
  margin-bottom: ${spacing(4)};
  min-width: 20px;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-bottom: 0;
  }
`

const Question = styled.span`
  ${Text('medium1', 'default')}
  margin-bottom: ${spacing(4)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-bottom: ${spacing(4)};
  }
`

const Answer = styled(SafeHtml)`
  ${Text('bodyText', 'default')}
  margin-bottom: ${spacing(6)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-bottom: ${spacing(8)};
  }
`

const WrapperStyles = css`
  display: flex;
  flex-direction: column;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    flex-direction: row;
  }

  &:last-child ${Answer} {
    margin-bottom: 0;
  }
`

const QuestionWrapper = styled.dt`
  ${WrapperStyles}
`

const AnswerWrapper = styled.dd`
  ${WrapperStyles}
`

export const QuestionAndAnswer = React.memo(
  ({ items }: QuestionAndAnswerProps) => {
    const i18nQuestionsAndAnswer = {
      question: i18n('widget.qa.question'),
      answer: i18n('widget.qa.answer'),
    }

    const renderedItems = items.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <QuestionWrapper>
            <QALetters> {i18nQuestionsAndAnswer.question} </QALetters>
            <Question> {item.question} </Question>
          </QuestionWrapper>
          <AnswerWrapper>
            <QALetters> {i18nQuestionsAndAnswer.answer} </QALetters>
            <Answer content={item.answer} />
          </AnswerWrapper>
        </React.Fragment>
      )
    })

    return <dl>{renderedItems}</dl>
  },
)
